import { getInstances } from "@studiometa/js-toolkit";
import { transition } from "@studiometa/js-toolkit/utils";
function withTransition(BaseClass) {
  class Transition extends BaseClass {
    /**
     * Config.
     */
    static config = {
      name: "Transition",
      options: {
        enterFrom: String,
        enterActive: String,
        enterTo: String,
        enterKeep: Boolean,
        leaveFrom: String,
        leaveActive: String,
        leaveTo: String,
        leaveKeep: Boolean,
        group: String
      }
    };
    /**
     * Get the transition target.
     */
    get target() {
      return this.$el;
    }
    /**
     * Trigger the enter transition.
     */
    async enter(target, { dispatch = true } = {}) {
      const { enterFrom, enterActive, enterTo, enterKeep, leaveTo } = this.$options;
      await Promise.all([
        transition(
          target ?? this.target,
          {
            // eslint-disable-next-line prefer-template
            from: (leaveTo + " " + enterFrom).trim(),
            active: enterActive,
            to: enterTo
          },
          enterKeep ? "keep" : void 0
        ),
        dispatch && this.dispatch("enter")
      ]);
    }
    /**
     * Trigger the leave transition.
     */
    async leave(target, { dispatch = true } = {}) {
      const { leaveFrom, leaveActive, leaveTo, leaveKeep, enterTo } = this.$options;
      await Promise.all([
        transition(
          target ?? this.target,
          {
            // eslint-disable-next-line prefer-template
            from: (enterTo + " " + leaveFrom).trim(),
            active: leaveActive,
            to: leaveTo
          },
          leaveKeep ? "keep" : void 0
        ),
        dispatch && this.dispatch("leave")
      ]);
    }
    /**
     * Dispatch the callback to related instances.
     */
    async dispatch(method) {
      const { group } = this.$options;
      if (!group) {
        return;
      }
      const promises = [];
      for (const instance of getInstances(Transition)) {
        if (instance !== this && instance.$options.group === group) {
          promises.push(instance[method](void 0, { dispatch: false }));
        }
      }
      await Promise.all(promises);
    }
  }
  return Transition;
}
export {
  withTransition
};
//# sourceMappingURL=withTransition.js.map
